<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="apn_is_load" parent="apn">
    <tab id="info" :name="translate('rpc_template.info')" :href="url+'/info'">
      <Info v-if="apn_is_load"
        :apn="apn_info"
        @update="get_apn"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              {{ translate('no_data') }}
            </h2>
            <router-link :to="{path:'/simcard_profile_list/apn_list'}">
              {{ translate('simcard_profile.apn_lists') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Info.vue'

export default {
  name: 'Apn',
  components: {
    Info,
    Tab,
    Tabs,
  },
  data () {
    return {
      apn_info: null,
      load: true,
    }
  },

  computed: {
    url () { return '/apn/' + this.$route.params.apn_id },
    cur_id () { return this.$route.params.apn_id },
    apn_is_load() { return this.apn_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'apn_section') {
        this.apn_info = null
        this.$store.commit('updateSelectedApn', null)
        this.get_apn()
      }
    },
    apn_info(){
      if (this.$route.name === 'apn_section' && this.apn_info) {
        this.$store.commit('updateOtherTitle', this.apn_info.apn)
      }
    }
  },

  activated(){
    this.get_apn()
  },

  deactivated() {
    this.$store.commit('updateSelectedApn', null)
    this.$store.commit('updateOtherTitle', '')
  },

  methods: {
    get_apn () {
      let id = this.cur_id
      if (!id) return
      this.load = this.apn_info === null
      this.$http.simcard.getSimcardOperatorApnInfo(id, (response) => {
        if (id !== this.cur_id) return
        this.apn_info = response.data
        this.$store.commit('updateSelectedApn', response.data)
        this.load = false
      }, (error) => {
        if (id !== this.cur_id) return
        this.load = false
        this.bad_answer_handler(error)
      })
    }
  }
}
</script>
